/**
 * Strip HTML / script tags from a string before sending to the API.
 * This is a lightweight frontend guard — the backend also sanitizes.
 *
 * @param {string} value
 * @param {number|null} maxLength  optional character cap
 * @returns {string}
 */
export function sanitizeText(value, maxLength = null) {
  if (typeof value !== 'string') return value;
  // Remove HTML tags
  let clean = value.replace(/<[^>]*>/g, '');
  // Decode common HTML entities (&lt; &gt; &amp; etc.)
  const txt = document.createElement('textarea');
  txt.innerHTML = clean;
  clean = txt.value;
  // Strip again in case entities encoded a tag
  clean = clean.replace(/<[^>]*>/g, '');
  clean = clean.trim();
  if (maxLength && clean.length > maxLength) {
    clean = clean.slice(0, maxLength);
  }
  return clean;
}

/**
 * Sanitize all string values in a plain object (shallow, in-place).
 * @param {object} obj
 * @param {string[]} fields  field names to sanitize
 * @returns {object}  same reference, mutated
 */
export function sanitizeFields(obj, fields) {
  for (const f of fields) {
    if (f in obj && typeof obj[f] === 'string') {
      obj[f] = sanitizeText(obj[f]);
    }
  }
  return obj;
}
